// A Stimulus controller to handle dropdown menus
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];
  static values = {
    open: { type: Boolean, default: false },
  };

  connect() {
    // Close dropdown when clicking outside
    this.clickOutsideHandler = this.closeOnClickOutside.bind(this);
    document.addEventListener("click", this.clickOutsideHandler);

    // Close dropdown when pressing escape
    this.escapeHandler = this.closeOnEscape.bind(this);
    document.addEventListener("keydown", this.escapeHandler);

    // Add transition classes to menu
    this.menuTarget.classList.add(
      "transition",
      "ease-out",
      "duration-100",
      "transform",
      "opacity-0",
      "scale-95"
    );

    // Habillage GO4S Design System : tous les menus déroulants de l'app
    // prennent le conteneur DS (.ds-pop). Spec : docs/design-system/REFERENCE.md §4
    this.menuTarget.classList.add("ds-pop");
  }

  disconnect() {
    // Clean up event listeners when controller is disconnected
    document.removeEventListener("click", this.clickOutsideHandler);
    document.removeEventListener("keydown", this.escapeHandler);
  }

  toggle() {
    this.openValue = !this.openValue;
    this.toggleMenu();
  }

  open() {
    this.openValue = true;
    this.toggleMenu();
  }

  close() {
    this.openValue = false;
    this.toggleMenu();
  }

  toggleMenu() {
    if (this.openValue) {
      // Show the menu with animation
      this.menuTarget.classList.remove("hidden");

      // Use setTimeout to ensure the transition happens after the element is visible
      setTimeout(() => {
        this.menuTarget.classList.remove("opacity-0", "scale-95");
        this.menuTarget.classList.add("opacity-100", "scale-100");
      }, 10);
    } else {
      // Hide the menu with animation
      this.menuTarget.classList.remove("opacity-100", "scale-100");
      this.menuTarget.classList.add("opacity-0", "scale-95");

      // Wait for the transition to finish before hiding the element
      setTimeout(() => {
        this.menuTarget.classList.add("hidden");
      }, 100);
    }
  }

  closeOnClickOutside(event) {
    // Don't close if clicking inside the controller element
    if (this.element.contains(event.target)) return;

    this.close();
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }

  showForm(event) {
    const formId = event.params.form;
    const formEl = document.getElementById(formId);
    if (formEl) {
      formEl.classList.remove("hidden");
    }
    this.close();
  }
}
